/* ===== menüleri açma ===== */
(function () {
  const DURATION = 250;       // ms
  const EASING   = 'ease';    // cubic-bezier de kullanabilirsin

  function expand(li, submenu) {
    // Açılışa hazırlan
    submenu.style.overflow   = 'hidden';
    submenu.style.transition = `height ${DURATION}ms ${EASING}`;

    // Önce görünür yap ki ölçebilelim
    const prevDisplay = submenu.style.display;
    submenu.style.display = 'block';

    // Başlangıç yüksekliği 0
    submenu.style.height = '0px';

    // Reflow (ölçüm tetikle)
    // eslint-disable-next-line no-unused-expressions
    submenu.offsetHeight;

    // Hedef yüksekliğe animasyon
    const target = submenu.scrollHeight;
    submenu.style.height = target + 'px';

    // Animasyon bitince auto'ya dön (içerik değişse bozulmasın)
    const onEnd = (ev) => {
      if (ev.propertyName !== 'height') return;
      submenu.style.height = '';
      submenu.style.overflow = '';
      submenu.removeEventListener('transitionend', onEnd);
    };
    submenu.addEventListener('transitionend', onEnd);

    li.classList.add('is--opend');
  }

  function collapse(li, submenu) {
    submenu.style.overflow   = 'hidden';
    submenu.style.transition = `height ${DURATION}ms ${EASING}`;

    // Mevcut yüksekliği sabitle
    const current = submenu.scrollHeight;
    submenu.style.height = current + 'px';

    // Reflow
    // eslint-disable-next-line no-unused-expressions
    submenu.offsetHeight;

    // 0'a animasyon
    submenu.style.height = '0px';

    const onEnd = (ev) => {
      if (ev.propertyName !== 'height') return;
      submenu.style.display = 'none';
      submenu.style.height = '';
      submenu.style.overflow = '';
      submenu.removeEventListener('transitionend', onEnd);
    };
    submenu.addEventListener('transitionend', onEnd);

    li.classList.remove('is--opend');
  }

  document.addEventListener('click', function (e) {
    const a = e.target.closest(
      '.t4s-item-level-0.t4s-menu-item-has-children > a'
    );
    if (!a) return;

    const plusIcon = a.querySelector('.t4s-mb-nav__icon');
    if (plusIcon && (e.target === plusIcon || plusIcon.contains(e.target))) {
      return; // temanın kendi + davranışını bozma
    }

    e.preventDefault();
    e.stopPropagation();

    const li = a.parentElement;
    const submenu = li.querySelector(':scope > .t4s-sub-menu');
    if (!submenu) return;

    const isOpen = li.classList.contains('is--opend');

    // Akordeon: aynı seviyedeki diğer açıkları animasyonla kapat
    const siblings = li.parentElement ? li.parentElement.children : [];
    for (const sib of siblings) {
      if (sib !== li && sib.classList && sib.classList.contains('is--opend')) {
        const sm = sib.querySelector(':scope > .t4s-sub-menu');
        if (sm) collapse(sib, sm);
      }
    }

    // Aç/Kapa animasyonlu
    if (isOpen) {
      collapse(li, submenu);
    } else {
      expand(li, submenu);
    }
  });

  // UX ipucu
  const style = document.createElement('style');
  style.textContent = `
    .t4s-item-level-0.t4s-menu-item-has-children > a { cursor: pointer; }
    @media (prefers-reduced-motion: reduce) {
      .t4s-sub-menu { transition: none !important; }
    }
  `;
  document.head.appendChild(style);
})();

/* ===== Collection header wiggle — move content by X px, then back, buttery smooth ===== */
(function () {
  // Yalnızca koleksiyon sayfalarında çalışsın
  if (!window.location.pathname.startsWith('/collections/')) return;

  // Slider kapsayıcı (HTML'e class eklemeye gerek yok)
  const SELECTOR  = '.t4s-top-list-collections.t4s-flickity-slider';
  const DURATION  = 420;                   // ms (ileri ve geri ayrı ayrı)
  const NUDGE_PX  = null;                  // sabit istersen örn. 100 yap (null = otomatik %12)

  /* ---------- yardımcılar ---------- */
  function getFlickityInstance(el){
    if (window.Flickity && typeof window.Flickity.data === 'function') {
      return window.Flickity.data(el);
    }
    if (window.jQuery) {
      const $el = window.jQuery(el);
      return $el.data('flickity') || $el.data('Flickity');
    }
    return el.flickity || el.flickityt4s || null;
  }
  const easeInOutQuad = t => (t < 0.5 ? 2*t*t : -1 + (4 - 2*t)*t);

  // rAF tabanlı Flickity.x tween (içerik gerçekten kayar)
  function tweenFlickityX(flkty, from, to, duration){
    return new Promise(resolve => {
      const t0 = performance.now();
      function step(now){
        const p = Math.min(1, (now - t0) / duration);
        const x = from + (to - from) * easeInOutQuad(p);
        flkty.x = x;
        flkty.positionSlider();
        if (p < 1) requestAnimationFrame(step); else resolve();
      }
      requestAnimationFrame(step);
    });
  }

  // Native scroll fallback (Flickity yoksa)
  function tweenScroll(el, to, duration){
    return new Promise(resolve => {
      const start = el.scrollLeft;
      const change = to - start;
      const t0 = performance.now();
      function step(now){
        const p = Math.min(1, (now - t0) / duration);
        el.scrollLeft = start + change * easeInOutQuad(p);
        if (p < 1) requestAnimationFrame(step); else resolve();
      }
      requestAnimationFrame(step);
    });
  }

  async function wiggleNative(el, nudgePx){
    const viewport = el.querySelector('.flickityt4s-viewport, .flickity-viewport') || el;
    const start = viewport.scrollLeft;
    // kullanıcı etkileşimi kısa süre kapalı
    const prevPE = viewport.style.pointerEvents;
    viewport.style.pointerEvents = 'none';
    await tweenScroll(viewport, start + nudgePx, DURATION);
    await tweenScroll(viewport, start, DURATION);
    viewport.style.pointerEvents = prevPE || '';
  }

  async function wiggleFlickity(el, nudgePx){
    const flkty = getFlickityInstance(el);
    if (!flkty) return wiggleNative(el, nudgePx);

    // Başlangıç konumu (Flickity negatif x)
    const startX = flkty.x;

    // X sınırları: 0 (en sol) ile minX (en sağ, negatif)
    const minX = Math.min(0, (flkty.size?.innerWidth || 0) - (flkty.slideableWidth || 0));

    // Sağ tarafı göstermek için x'i daha negatif yap; ama sınırı aşma
    const toX = Math.max(minX, startX - nudgePx);

    // Wiggle sırasında drag kapalı kalsın
    const prevDraggable = flkty.options.draggable;
    flkty.options.draggable = false;
    if (flkty.unbindDrag) flkty.unbindDrag();

    // İleri → geri
    await tweenFlickityX(flkty, startX, toX, DURATION);
    await tweenFlickityX(flkty, toX, startX, DURATION);

    // Güvence: tam startX'e sabitle (çift onay)
    flkty.x = startX;
    flkty.positionSlider();
    requestAnimationFrame(() => {
      flkty.x = startX;
      flkty.positionSlider();

      // Drag'ı geri aç
      flkty.options.draggable = prevDraggable;
      if (prevDraggable && flkty.bindDrag) flkty.bindDrag();
    });
  }

  function run(){
    const el =
      document.querySelector(SELECTOR + '.flickityt4s-enabled, ' + SELECTOR + '.flickity-enabled') ||
      document.querySelector(SELECTOR);
    if (!el) return;

    const viewport = el.querySelector('.flickityt4s-viewport, .flickity-viewport') || el;

    // X mesafesi: sabit tanımlıysa onu kullan; yoksa görünür genişliğin ~%12’si (40–140 px arası)
    const auto = Math.round((viewport.clientWidth || 320) * 0.35);
    const nudge = Math.max(40, Math.min(140, NUDGE_PX ?? auto));

    const flkty = getFlickityInstance(el);
    if (flkty) {
      // Flickity bazen geç init olur; hazır değilse kısa retry, sonra fallback
      let tries = 0;
      const tick = () => {
        const inst = getFlickityInstance(el);
        if (inst && (inst.cells?.length ?? 0) > 0) return wiggleFlickity(el, nudge);
        if (tries++ < 5) return setTimeout(tick, 200);
        wiggleNative(el, nudge);
      };
      tick();
    } else {
      wiggleNative(el, nudge);
    }
  }

  document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:select', run);
  setTimeout(run, 700); // ekstra tetik
})();

// live chat

(function () {
  // --- Ortak yardımcılar ---
  function getHost() {
    return (
      document.querySelector('shopify-chat') ||
      document.querySelector('#ShopifyChat') ||
      document.querySelector('shopify-inbox') ||
      document.querySelector('#ShopifyInbox')
    );
  }

  function getRoot() {
    var host = getHost();
    return host && host.shadowRoot ? host.shadowRoot : null;
  }

  function getToggle(root) {
    if (!root) return null;
    return (
      root.querySelector('.chat-toggle') ||
      root.querySelector('button[aria-haspopup="dialog"]') ||
      root.querySelector('button')
    );
  }

  function isOpen(root) {
    return !!(root &&
      (root.querySelector('[role="dialog"]') ||
       root.querySelector('iframe[title*="Chat" i]') ||
       root.querySelector('.conversation, .chat-window'))
    );
  }

  function hideLauncher(toggle) {
    if (!toggle) return;
    // Sadece görünmez yap, davranışını bozma
    toggle.style.opacity = '0';
    toggle.style.transform = 'scale(0)';
    // pointerEvents vs. dokunmuyoruz ki Shopify'ın kendi click mantığına engel olmayalım
  }

  function showLauncher(toggle) {
    if (!toggle) return;
    toggle.style.opacity = '';
    toggle.style.transform = '';
  }

  // --- Sayfa açıldığında: widget yüklenince balonu gizle ---
  (function waitAndHideInitially() {
    var tries = 0, maxTries = 120, delay = 150;

    (function loop() {
      var root = getRoot();
      var toggle = getToggle(root);

      if (toggle) {
        hideLauncher(toggle);
        return;
      }

      if (tries++ < maxTries) {
        setTimeout(loop, delay);
      }
    })();
  })();

  // --- Chat açma fonksiyonu ---
  function openInbox() {
    var tries = 0, maxTries = 80, delay = 150;

    (function waitForWidget() {
      var root = getRoot();
      var toggle = getToggle(root);

      if (toggle) {
        // Butonu görünür yap (X olarak da görünsün)
        showLauncher(toggle);

        // Chat kapalıysa aç
        if (!isOpen(root)) {
          toggle.click();
        }

        // Kullanıcı X'e basıp chat'i kapatınca balonu tekrar gizle
        function handleToggleClick() {
          setTimeout(function () {
            var currentRoot = getRoot();
            if (!isOpen(currentRoot)) {
              // Chat kapalı hale geldi → balonu gizle
              var currentToggle = getToggle(currentRoot) || toggle;
              hideLauncher(currentToggle);
              toggle.removeEventListener('click', handleToggleClick);
            }
          }, 100);
        }

        toggle.addEventListener('click', handleToggleClick);

      } else if (tries++ < maxTries) {
        setTimeout(waitForWidget, delay);
      } else {
        // Fallback
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('show_chat', '1');
          window.location.href = url.toString();
        } catch (e) {
          window.location.href = '?show_chat=1';
        }
      }
    })();
  }

  // --- Ortak tetikleyici handler (click + touch için) ---
  function handleTrigger(e) {
    var trigger = e.target.closest('[data-open-chat]');
    if (!trigger) return;

    // Mobilde double trigger olmaması için
    e.preventDefault();
    e.stopPropagation();

    openInbox();
  }

  // Desktop + mobil:
  document.addEventListener('click', handleTrigger, { passive: false });
  document.addEventListener('touchend', handleTrigger, { passive: false });

})();

// preload
  document.addEventListener('DOMContentLoaded', function() {
    const preloader = document.getElementById('talishko-preloader');
    if (!preloader) return;

    // 1. GÖREV: Sayfa yüklendiğinde perdeyi kaldır
    window.addEventListener('load', function() {
      preloader.classList.add('preloader-hidden');
    });

    setTimeout(function() {
      preloader.classList.add('preloader-hidden');
    }, 2500);

    // 2. GÖREV: Sadece izin verilen sayfalara tıklandığında perdeyi indir
    const links = document.querySelectorAll('a[href^="/"], a[href^="' + window.location.origin + '"]');
    
    links.forEach(function(link) {
      link.addEventListener('click', function(e) {
        
        if (e.defaultPrevented) return;

        // Menü, Çekmece ve Popup Engelleyiciler
        if (link.hasAttribute('aria-haspopup') || link.hasAttribute('aria-expanded') || link.hasAttribute('aria-controls') || link.hasAttribute('data-toggle') || link.closest('summary')) {
          return;
        }

        // Standart Engelleyiciler (Sepet, Variant, Yeni Sekme vb.)
        if (link.target === '_blank' || link.href.includes('#') || link.getAttribute('href') === '#' || link.href.includes('javascript:void(0)') || link.href.includes('mailto:') || link.href.includes('tel:') || link.href.includes('?variant=') || e.ctrlKey || e.metaKey || link.hasAttribute('download')) {
          return;
        }

        // --- YENİ EKLENEN KISITLAMA: Gidilen adres izinli listemizde mi? ---
        const href = link.getAttribute('href');
        if (href) {
          const isAllowedPage = href.includes('/products/') ||  
                                href.includes('/policies/');
          
          if (!isAllowedPage) {
            return; // Eğer Ana Sayfaya, Sepete veya Bloga gidiyorsa perdeyi İNDİRME
          }
        }
        
        // Her şey uyuyorsa perdeyi kapat ve yeni sayfanın yüklenmesini bekle
        preloader.classList.remove('preloader-hidden');
      });
    });
  });

  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      const preloader = document.getElementById('talishko-preloader');
      if (preloader) preloader.classList.add('preloader-hidden');
    }
  });

  document.addEventListener("DOMContentLoaded", function() {
    // Tarayıcının varsayılan kaydırma (scroll) fonksiyonunu yedekliyoruz
    const originalScrollIntoView = Element.prototype.scrollIntoView;

    // Fonksiyonu yeniden yazıp araya giriyoruz
    Element.prototype.scrollIntoView = function(options) {
      
      // KURAL 1: Ekran genişliği 1025px ve üzeriyse (SADECE PC/MASAÜSTÜ İSE) çalışsın
      if (window.innerWidth >= 1025) {
        
        // KURAL 2: Kaydırılmak istenen öğe 'ilk görsel' ise
        if (this.classList.contains('t4s-product__media-item') && !this.previousElementSibling) {
          
          // Temanın yarım kaydırmasını iptal et ve sayfayı kusursuzca en tepeye kaydır
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          return; // İşlemi burada kes, aşağıdaki orijinal kodu çalıştırma
        }
      }
      
      // Eğer kullanıcı MOBİL/TABLET'te ise veya tıklanan şey 2./3. görsel ise:
      // Temanın orijinal işlemini yapmasına hiçbir müdahale etmeden izin ver.
      originalScrollIntoView.call(this, options);
    };
  });

// --- 1. GENEL KAYDIRMA FONKSİYONLARI ---
document.addEventListener('DOMContentLoaded', () => {
    const getHeaderOffset = () => window.innerWidth <= 768 ? 280 : 160;

    const killThemeScroll = () => {
        if (typeof window.jQuery !== 'undefined') {
            window.jQuery('html, body').stop(true, false);
        }
    };

    const openAndScroll = (targetElementId) => {
        const targetEl = document.getElementById(targetElementId);
        if (!targetEl) return;

        const parentTab = targetEl.closest('.t4s-tab-content');
        
        if (parentTab) {
            const tabBtns = document.querySelectorAll(`[data-t4s-tab-item][href="#${parentTab.id}"], [data-t4s-tab-item][data-target="#${parentTab.id}"]`);
            
            let visibleBtn = null;
            for (let btn of tabBtns) {
                if (btn.offsetWidth > 0 || btn.offsetHeight > 0) {
                    visibleBtn = btn;
                    break;
                }
            }

            if (visibleBtn && !visibleBtn.classList.contains('t4s-active')) {
                if (typeof window.jQuery !== 'undefined') {
                    window.jQuery(visibleBtn).trigger('click');
                } else {
                    visibleBtn.click();
                }
                
                setTimeout(killThemeScroll, 10);
                setTimeout(killThemeScroll, 50);
            }
        }

        setTimeout(() => {
            killThemeScroll(); 
            
            const rect = targetEl.getBoundingClientRect();
            if (rect.height > 0 || (parentTab && parentTab.classList.contains('t4s-active'))) {
                const offsetPosition = rect.top + window.scrollY - getHeaderOffset();
                
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        }, 400); 
    };

    document.addEventListener('click', (e) => {
        const starTrigger = e.target.closest('.loox-rating, a[href="#looxReviews"]');
        if (starTrigger) {
            e.preventDefault();
            e.stopPropagation(); 
            e.stopImmediatePropagation(); 
            
            const reviewId = document.getElementById('talishko-community-report') ? 'talishko-community-report' : 'looxReviews';
            openAndScroll(reviewId);
        }

        const readMoreBtn = e.target.closest('.t4s-product__description_readm');
        if (readMoreBtn) {
            e.preventDefault();
            e.stopPropagation(); 
            e.stopImmediatePropagation(); 
            
            openAndScroll('talishko-full-description');
        }
    }, true); 
});

document.addEventListener('DOMContentLoaded', () => {
    if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
      const bannerItems = document.querySelectorAll('.t4s-banner-inner');
      
      bannerItems.forEach(item => {
        item.addEventListener('mousemove', (e) => {
          const rect = item.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;
          
          // Merkezden uzaklığa göre hareketi hesapla (Kutu dışına taşmasın diye max 12px)
          const centerX = rect.width / 2;
          const centerY = rect.height / 2;
          const moveX = ((x - centerX) / centerX) * 12; 
          const moveY = ((y - centerY) / centerY) * 12;
          
          item.style.setProperty('--move-x', `${moveX}px`);
          item.style.setProperty('--move-y', `${moveY}px`);
        });

        // Fare çıkınca merkeze yumuşakça dönmesi için sıfırla
        item.addEventListener('mouseleave', () => {
          item.style.setProperty('--move-x', `0px`);
          item.style.setProperty('--move-y', `0px`);
        });
      });
    }
  });


